import { useTranslation } from "react-i18next";
import { RatingWithLaurel } from "./rating-with-laurel.component";

type ExpertReviewHeaderProps = {
	overallRating: number;
	reviewerName: string;
};

export function ExpertReviewHeader({
	overallRating,
	reviewerName,
}: ExpertReviewHeaderProps) {
	const { t } = useTranslation("product");

	return (
		<div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
			<div className="flex flex-col md:flex-row items-center gap-4">
				<div data-testid="expert-review-rating">
					<RatingWithLaurel rating={overallRating} size="md" />
				</div>
				<div className="flex flex-col ml-2 text-center md:text-left">
					<h2
						className="text-body-lg-emphasis text-gray-700"
						data-testid="expert-review-title"
					>
						{t("expertReview.title")}
					</h2>
					<p
						className="text-body-sm text-gray-500"
						data-testid="expert-review-reviewed-by"
					>
						{t("expertReview.reviewedBy")}{" "}
						{reviewerName || t("expertReview.reviewedBy.noDoctor")}
					</p>
				</div>
			</div>
		</div>
	);
}
